export default __webpack_public_path__ + "static/media/3_Rooms.cac89f2e.png";